import { MuiThemeProvider } from "@material-ui/core";
import * as React from "react";
import { MainTheme } from "./MainTheme";

interface IProps {
  children: React.ReactNode;
}

// tslint:disable-next-line:no-empty-interface
interface IState {}

export class ThemeProvider extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <MuiThemeProvider theme={MainTheme}>
        {this.props.children}
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/ThemeProvider.tsx